import gql from 'graphql-tag';

const consumeContractCreditsMutation = gql`
mutation consumeCredits(
  $organisationId: String!,
  $owner: String!,
  $amount: Int!,
  $consumeBy: String!,
  $reason: String,
  $notes: String
  ) {
  consumeCredits(organisationId: $organisationId, owner: $owner, amount: $amount, consumeBy: $consumeBy, reason: $reason, notes: $notes)
}
`;

const consumeContractCredits = (organisationId) => ({
  mutation: consumeContractCreditsMutation,
  module: 'organisations',
  buildVariables: ({
    owner,
    amount,
    consumeBy,
    reason,
    notes







  }) => ({
    organisationId,
    owner,
    amount,
    consumeBy,
    reason,
    notes
  })
});

export default consumeContractCredits;